import BasicTable from './BasicTable';
import PaginatedTable from './PaginatedTable';

export { BasicTable, PaginatedTable };
